/**
 * Shared by the two ways a custom overlay gets applied - the Apply button and
 * the "Save changes?" prompt behind Back. Both must create the object tracking
 * job before the AGD is committed, and both must keep the user on the page when
 * that fails.
 *
 * The in-flight flag lives in the store on purpose: the mixin is installed on
 * two live components, so a per-component flag would let Back fire a second job
 * while Apply is still waiting for the first.
 */
import app from 'app';
import { mapActions, mapState } from 'vuex';

export default {
  computed: {
    ...mapState('assetEditor', ['objectTrackingInFlight']),
  },

  methods: {
    ...mapActions('assetEditor', ['ENSURE_OBJECT_TRACKING']),

    /**
     * @return {Promise<Boolean>} true when it is safe to apply
     */
    ensureObjectTracking() {
      if (this.objectTrackingInFlight) {
        return Promise.resolve(false);
      }

      return this.ENSURE_OBJECT_TRACKING()
        .then(() => true)
        .catch((e) => {
          app.doctorController.report(
            `ENSURE_OBJECT_TRACKING failed: ${(e && e.error) || e}`
          );
          app.dialog.error({
            type: app.dialog.types.ERROR_1,
            title: app.culture.get('assetEditor.objectTrackingFailedTitle'),
            description: app.culture.get(
              'assetEditor.objectTrackingFailedText'
            ),
          });
          return false;
        });
    },
  },
};
